import React, { useState, useEffect } from "react";
import styles from "./orders.module.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  changeShortDateFormat, changeOneDateFormat, changeOneDateFormatDDMMYYYYHHMM,
  getDataFromRoutes, setMetaTags, getStatusName, returnFIO, returnPayer
} from "../../utils/util_functions";
import {
  getInvoiceThunk, getBillThunk, getBillOfLadingThunk,
  patchRequestBillThunk, patchRequestInvoiceThunk,
  patchUploadOrderFileThunk, patchOrderThunk, patchMakeInvoicedThunk,
  patchRequestAddPayThunk, patchSetDefPaymentThunk,
  patchMakeAwaitReceiptOrderThunk, patchMakeReceivedOrderThunk
} from "../../services/actions/orders_actions";
import { getProductsThunk, getProductsAndTransportedThunk } from "../../services/actions/products_actions";
import { getCurrOrderThunk, CURR_ORDER_CLEAR } from "../../services/actions/curr_order_actions";
import { getCookie } from "../../utils/cookie";
import {
  STATUSES_VALUES, USER_ROLES, TEXT_CANCEL_ORDER, TITLE_CONFIRM,
  TypeConfirm,
  ORDER_STATUSES,
  PAYMENT_STATUSES, MAX_DEF_PAYMENT,
  TypeEditOrder,
  TITLE_EDIT_ORDER_COMMENT, TITLE_EDIT_ORDER_SHIPPING,
  TITLE_EDIT_ORDER_FIRM, TITLE_ERROR, SHIPPING_TYPES,
  TEXT_ERROR_REPEAT, TITLE_EDIT_ORDER_PRODUCTS
} from "../../utils/constants";
import Loader from "../../components/loader/loader";
import {
  getLoading, getCurrOrder, getRoutes, getUser, getCustomer,
  getShippings
} from "../../services/selectors";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import OrderGraph from "../../components/order_graph/order_graph";
import UserData from "../../components/collapsed_data_list/user_data";
import FirmData from "../../components/collapsed_data_list/payer_data";
import ShippingData from "../../components/collapsed_data_list/shipping_data";
import CollapsedContainer from "../../components/collapsed_container/collapsed_container";
import FileInput from "../../components/file_input/file_input";
import {
  SET_PORTAL_API, SET_PORTAL_CONFIRM, SET_PORTAL_EDIT_ORDER
} from "../../services/actions/portal_actions";
import ProductInOrder from "../../components/product_in_order/product_in_order";


const Order = () => {

  const user = useSelector(getUser);
  const { token } = useParams();
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const { order } = useSelector(getCurrOrder);

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  const routes = useSelector(getRoutes);
  const location = useLocation();
  const navigate = useNavigate();


  const shippings = useSelector(getShippings);


  const [selfieShipping, setSelfieShipping] = useState(true);
  const [buttonRepeatEnabled, setButtonRepeatEnabled] = useState(false);
  const [buttonCancelEnabled, setButtonCancelEnabled] = useState(false);
  const [buttonAwaitReceiptEnabled, setButtonAwaitReceiptEnabled] = useState(true);
  const [buttonReceivedEnabled, setButtonReceivedEnabled] = useState(true);
  const [errorEntrance, setErrorEntrance] = useState(false);
  const [entrance, setEntrance] = useState(null);
  const [errorDefPayment, setErrorDefPayment] = useState(false);
  const [defPayment, setDefPayment] = useState(null);
  const [showDownloads, setShowDownloads] = useState(false);
  const [showCustomer, setShowCustomer] = useState(false);
  const [showPayer, setShowPayer] = useState(false);
  const [showShipping, setShowShipping] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showUploads, setShowUploads] = useState(false);
  const [showRequests, setShowRequests] = useState(false);
  const [showDefPayment, setShowDefPayment] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showControl, setShowControl] = useState(false);

  const [remainingPayment, setRemainingPayment] = useState(order.total_price - order.total_paid);


  useEffect(() => {
    return () => {
      dispatch({ type: CURR_ORDER_CLEAR });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes, '', token);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [location])

  useEffect(() => {
    setButtonRepeatEnabled(order.status === STATUSES_VALUES.received)
    setButtonCancelEnabled(
      ((order.status === STATUSES_VALUES.created ||
        order.status === STATUSES_VALUES.invoiced) &&
        order.total_paid === 0)
    )
    setRemainingPayment(order.total_price - order.total_paid);

    // включение кнопки "ОЖИДАЕТ ПОЛУЧЕНИЯ"
    // setButtonAwaitReceiptEnabled()

    // включение кнопки "ПОЛУЧЕН"
    // setButtonReceivedEnabled()

    // eslint-disable-next-line
  }, [order]);

  useEffect(() => {
    dispatch(getCurrOrderThunk(accessToken, refreshToken, token));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    let currShipping = shippings.find(shipping => shipping.name === order.order_shipping_name);
    if (currShipping?.type === SHIPPING_TYPES.selfie) {
      setSelfieShipping(true);
    } else {
      setSelfieShipping(false);
    }
  }, [order, shippings]);


  const changePaid = (e) => {
    setEntrance(e.target.value);

    if (isNaN(e.target.value) || isNaN(parseInt(e.target.value))) {
      e.target.value = e.target.value.slice(0, e.target.value.length - 1);
      setErrorEntrance(true);
      return null;
    } else if (e.target.value > (remainingPayment)) {
      setErrorEntrance(true);
      return null;
    } else if (e.target.value < 1) {
      setErrorEntrance(true);
      return null;
    } else {
      setErrorEntrance(false);
    }
  }

  const changeDefPayment = (e) => {
    setDefPayment(e.target.value);

    if (isNaN(e.target.value) || isNaN(parseInt(e.target.value))) {
      e.target.value = e.target.value.slice(0, e.target.value.length - 1);
      setErrorDefPayment(true);
      return null;
    } else if (e.target.value > MAX_DEF_PAYMENT) {
      e.target.value = e.target.value.slice(0, e.target.value.length - 1);
      setErrorDefPayment(true);
      return null;
    } else if ((e.target.value < 1) && !order.current_def_payment) {
      setErrorDefPayment(true);
      return null;
    } else if (e.target.value < 0) {
      setErrorDefPayment(true);
      return null;
    } else {
      setErrorDefPayment(false);
    }
  }

  const handleGetBill = () => {
    const name = (
      `Счёт_по_заказу_No_${order.id}_от_` +
      `${changeShortDateFormat(order.created_date)}.pdf`
    );
    dispatch(getBillThunk(order.id, name));
  }

  const handleGetInvoice = () => {
    const name = (
      `Товарная_накладная_по_заказу_No_${order.id}_от_` +
      `${changeShortDateFormat(order.created_date)}.pdf`
    );
    dispatch(getInvoiceThunk(order.id, name));
  }

  const handleGetBillOfLading = () => {
    const ext = order.bill_of_lading.slice(order.bill_of_lading.lastIndexOf('.') + 1);
    const name = (
      `Транспортная_накладная_по_заказу_No_${order.id}_от_` +
      `${changeShortDateFormat(order.created_date)}.${ext}`
    );
    dispatch(getBillOfLadingThunk(order.id, name));
  }


  const handleUploadBill = (file) => {
    const formData = new FormData();
    formData.append('bill', file);
    dispatch(patchUploadOrderFileThunk(order.id, formData, 'bill'));
  }

  const handleUploadInvoice = (file) => {
    const formData = new FormData();
    formData.append('invoice', file);
    dispatch(patchUploadOrderFileThunk(order.id, formData, 'invoice'));
  }

  const handleUploadBillOfLading = (file) => {
    const formData = new FormData();
    formData.append('bill_of_lading', file);
    dispatch(patchUploadOrderFileThunk(order.id, formData, 'bill_of_lading'));
  }

  const handleRequestBill = () => {
    dispatch(patchRequestBillThunk(order.id));
  }

  const handleRequestInvoice = () => {
    dispatch(patchRequestInvoiceThunk(order.id));
  }

  const handleConfirmBill = () => {
    dispatch(patchMakeInvoicedThunk(accessToken, accessToken, order.id));
  }


  const handleRepeatOrder = () => {
    // повторение заказа
    if (order.status === STATUSES_VALUES.received) {
      // проверяем доступность и количество товаров
      dispatch(
        getProductsAndTransportedThunk(
          accessToken, accessToken, order.productsinorder_set, order.customer, navigate, order)
      );
    } else {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: TEXT_ERROR_REPEAT
      });
    }
  }

  const handleAwaitReceipt = () => {
    dispatch(patchMakeAwaitReceiptOrderThunk(accessToken, refreshToken, order.id));
  }

  const handleReceived = () => {
    dispatch(patchMakeReceivedOrderThunk(accessToken, refreshToken, order.id));
  }

  const addDays = (created_date, current_def_payment, days) => {
    let result = new Date(created_date);
    const c_d_p = isNaN(parseInt(current_def_payment)) ? 0 : parseInt(current_def_payment);
    const d = isNaN(parseInt(days)) ? null : parseInt(days);
    if (typeof d === 'number') {
      result.setDate(result.getDate() + d);
    } else {
      result.setDate(result.getDate() + c_d_p);
    }
    return result;
  }


  const handleCancelOrder = () => {
    dispatch({
      type: SET_PORTAL_CONFIRM,
      title: TITLE_CONFIRM,
      text: TEXT_CANCEL_ORDER,
      typeConfirm: TypeConfirm.CancelOrder,
      order
    });
  }

  const handleAddPay = () => {
    dispatch(patchRequestAddPayThunk(order.id, { entrance }));
    setEntrance(null);
  }

  const handleAddRemainingPay = () => {
    dispatch(patchRequestAddPayThunk(order.id, { entrance: remainingPayment.toString() }));
    setEntrance(null);
  }

  const handleSetDefPayment = () => {
    dispatch(patchSetDefPaymentThunk(order.id, { current_def_payment: defPayment }));
    setDefPayment(null);
  }

  const handleEditComment = () => {
    dispatch({
      type: SET_PORTAL_EDIT_ORDER,
      typeEditOrder: TypeEditOrder.EditComment,
      title: TITLE_EDIT_ORDER_COMMENT,
      order,
      customer: order.customer
    });
  }

  const handleEditShipping = () => {
    dispatch({
      type: SET_PORTAL_EDIT_ORDER,
      typeEditOrder: TypeEditOrder.EditShipping,
      title: TITLE_EDIT_ORDER_SHIPPING,
      order,
      customer: order.customer
    });
  }

  const handleEditPayer = () => {
    dispatch({
      type: SET_PORTAL_EDIT_ORDER,
      typeEditOrder: TypeEditOrder.EditFirm,
      title: TITLE_EDIT_ORDER_FIRM,
      order,
      customer: order.customer
    });
  }

  const handleEditProducts = () => {
    // редактирование структуры заказа
    dispatch({
      type: SET_PORTAL_EDIT_ORDER,
      typeEditOrder: TypeEditOrder.EditProducts,
      title: TITLE_EDIT_ORDER_PRODUCTS,
      order,
      customer: order.customer
    });
  }

  return (
    <main className="main">
      <div className={styles.container}>
        {isLoading ? <Loader /> :
          <>
            {Object.entries(order).length > 0 ?
              <>
                <h2 className="title">Заказ № {order.id}</h2>
                <section className={styles.section}>
                  <OrderGraph order={order} selfieShipping={selfieShipping} />
                </section>
                <section className={styles.section}>
                  <p className={`subSubtitle subSubtitle__left`}>
                    <span className="fw500">
                      Статус заказа:
                    </span>
                    &#160;{getStatusName(order.status)}
                  </p>
                  <p className={`subSubtitle subSubtitle__left`}>
                    <span className="fw500">
                      Сумма заказа:
                    </span>
                    &#160;{(order.total_price).toLocaleString()} &#160;₽
                  </p>
                  <p className={`subSubtitle subSubtitle__left`}>
                    <span className="fw500">
                      Оплачено:
                    </span>
                    &#160;{(order.total_paid).toLocaleString()} &#160;₽

                  </p>

                  {user.role !== USER_ROLES.customer &&
                    <CollapsedContainer label={'Пользователь'} labelValue={returnFIO(order)}
                      showContent={showCustomer} setShowContent={setShowCustomer}
                    >
                      <UserData customer={order.customer} />
                    </CollapsedContainer>
                  }

                  <CollapsedContainer label={'Состав заказа'} edit={true}
                    showContent={showProducts} setShowContent={setShowProducts}
                    clickEdit={handleEditProducts}
                  >
                    <div className="w_100_per">
                      <ProductInOrder
                        productsinorder_set={order.productsinorder_set}
                      />
                    </div>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Плательщик'} labelValue={returnPayer(order)} edit={true}
                    showContent={showPayer} setShowContent={setShowPayer}
                    clickEdit={handleEditPayer}
                  >
                    <FirmData firm={order.firm} customer={order.customer} />
                  </CollapsedContainer>

                  <CollapsedContainer label={'Отсрочка оплаты'} labelValue={`${order.current_def_payment} дней`}
                    showContent={showDefPayment} setShowContent={setShowDefPayment}
                  >
                    <p className={`subSubtitle subSubtitle__left`}>
                      Отсрочка оплаты по умолчанию:
                      <span className="fw500">
                        &#160;{order.firm ? order.firm.default_def_payment : 0} &#160;дней
                      </span>
                    </p>
                    <p className={`subSubtitle subSubtitle__left`}>
                      Отсрочка оплаты в этом заказе:
                      <div className={styles.defPaymentGroup}>
                        <div className={styles.defPayInputContainer}>
                          <input
                            type="string"
                            className="input"
                            placeholder={`${order.current_def_payment}`}
                            value={defPayment}
                            onChange={changeDefPayment}
                            autoComplete="off"
                          />
                          <p className={styles.text}>
                            {(order.current_def_payment || defPayment) && ('до ' +
                              addDays(order.created_date, order.current_def_payment, defPayment)
                                .toLocaleDateString('ru-RU', { month: 'long', day: 'numeric', year: 'numeric' })
                            )}
                          </p>
                        </div>
                        {errorDefPayment && defPayment &&
                          <p className={`${styles.text} red`}>
                            введите до {MAX_DEF_PAYMENT} дней
                          </p>
                        }
                      </div>
                      <button
                        className={`button button__medium ${(!defPayment || errorDefPayment) && 'button_disabled'}`}
                        onClick={handleSetDefPayment}
                        disabled={!defPayment || errorDefPayment}
                      >
                        Изменить отсрочку
                      </button>
                    </p>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Доставка'} labelValue={order.order_shipping_name} edit={true}
                    showContent={showShipping} setShowContent={setShowShipping}
                    clickEdit={handleEditShipping}
                  >
                    <ShippingData
                      order_shipping_name={order.order_shipping_name}
                      order_shipping_description={order.order_shipping_description} />
                  </CollapsedContainer>

                  <CollapsedContainer label={'Комментарий'} edit={true}
                    labelValue={order.comment ? order.comment.split(' ')[0] + '...' : 'нет'}
                    clickEdit={handleEditComment}
                    showContent={showComment} setShowContent={setShowComment}
                  >
                    <textarea name="comment" id="comment" className="textarea"
                      value={order.comment}
                      readOnly
                    />
                  </CollapsedContainer>

                  <CollapsedContainer label={'Запрос документов'}
                    showContent={showRequests} setShowContent={setShowRequests}
                  >
                    <div className={styles.downloadContainer}>
                      <div className={styles.buttonGroup}>
                        <p className={
                          `${styles.text} ${(order.bill_request_date && !order.bill) && 'red'}`
                        }>
                          {!order.bill_request_date ? (<span>&nbsp;</span>) :
                            <span>запрошен: {changeOneDateFormatDDMMYYYYHHMM(order.bill_request_date)}</span>}
                        </p>
                        <button
                          className={`button button__medium button__colorReverse`}
                          onClick={handleRequestBill}
                        >
                          Счёт
                        </button>
                      </div>
                      <div className={styles.buttonGroup}>
                        <p className={
                          `${styles.text} ${(order.invoice_request_date && !order.invoice) && 'red'}`
                        }>
                          {!order.invoice_request_date ? (<span>&nbsp;</span>) :
                            <span>запрошен: {changeOneDateFormatDDMMYYYYHHMM(order.invoice_request_date)}</span>}
                        </p>
                        <button
                          className={`button button__medium button__colorReverse`}
                          onClick={handleRequestInvoice}
                        >
                          Товарная накладная
                        </button>
                      </div>
                    </div>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Загрузка документов'}
                    showContent={showUploads} setShowContent={setShowUploads}
                  >
                    <div className={styles.downloadContainer}>
                      <div className={styles.buttonUploadGroup}>
                        <p className={styles.text}>
                          {!order.bill_upload_date ? (<span>&nbsp;</span>) :
                            <span>загружен: {changeOneDateFormatDDMMYYYYHHMM(order.bill_upload_date)}</span>}
                        </p>
                        <FileInput
                          label={'Счёт'}
                          name={'bill_input'}
                          extensions={['pdf']}
                          uploadThunk={handleUploadBill}
                        />
                        {(user.role === USER_ROLES.superuser || user.role === USER_ROLES.manager) &&
                          order.status === STATUSES_VALUES.created && order.bill &&
                          <button
                            className={`button button__medium button__red__colorReverse`}
                            onClick={handleConfirmBill}
                          >
                            Подтвердить
                          </button>
                        }
                      </div>
                      <div className={styles.buttonUploadGroup}>
                        <p className={styles.text}>
                          {!order.invoice_upload_date ? (<span>&nbsp;</span>) :
                            <span>загружен: {changeOneDateFormatDDMMYYYYHHMM(order.invoice_upload_date)}</span>}
                        </p>
                        <FileInput
                          label={'Товарная накладная'}
                          name={'invoice_input'}
                          extensions={['pdf']}
                          uploadThunk={handleUploadInvoice}
                        />
                      </div>
                      {
                        !selfieShipping &&
                        <div className={styles.buttonUploadGroup}>
                          <p className={styles.text}>
                            {!order.bill_of_lading_upload_date ? (<span>&nbsp;</span>) :
                              <span>загружен: {changeOneDateFormatDDMMYYYYHHMM(order.bill_of_lading_upload_date)}</span>}
                          </p>
                          <FileInput
                            label={'Транспортная накладная'}
                            name={'invoice_bill_of_lading'}
                            extensions={['pdf', 'jpg', 'jpeg']}
                            uploadThunk={handleUploadBillOfLading}
                          />
                        </div>
                      }
                    </div>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Скачивание документов'}
                    showContent={showDownloads} setShowContent={setShowDownloads}
                  >
                    <div className={styles.downloadContainer}>
                      <div className={styles.buttonGroup}>
                        <button
                          className={`button button__medium ${!order.bill && 'button_disabled'}`}
                          onClick={handleGetBill}
                          disabled={!order.bill}
                        >
                          Счёт
                        </button>
                      </div>
                      <div className={styles.buttonGroup}>
                        <button
                          className={`button button__medium ${!order.invoice && 'button_disabled'}`}
                          onClick={handleGetInvoice}
                          disabled={!order.invoice}
                        >
                          Товарная накладная
                        </button>
                      </div>

                      {
                        !selfieShipping &&
                        <div className={styles.buttonGroup}>
                          <button
                            className={`button button__medium ${!order.bill_of_lading && 'button_disabled'}`}
                            onClick={handleGetBillOfLading}
                            disabled={!order.bill_of_lading}
                          >
                            Транспортная накладная
                          </button>
                        </div>
                      }
                      {/* ДЕЛАТЬ!!! */}
                      <div className={styles.buttonGroup}>
                        <button
                          className={`button button__medium`}
                        >
                          Бланк заказа
                        </button>
                      </div>
                    </div>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Внесение платежей'}
                    showContent={showAddPayment} setShowContent={setShowAddPayment}
                  >
                    <div className={styles.downloadContainer}>
                      <div className={styles.buttonGroup}>
                        <div className={styles.inputGroup}>
                          <p className={`${styles.text} ${styles.text__wordWrap}`}>
                            Счёт на {order.total_price} руб., ранее оплачено {order.total_paid} руб.
                          </p>
                          <input
                            type="text"
                            className="input"
                            placeholder="Поступило"
                            onChange={changePaid}
                            autoComplete="off"
                          />
                          {errorEntrance && entrance &&
                            <p className={`${styles.text} red`}>
                              введите целое положительное число до {remainingPayment}
                            </p>
                          }
                        </div>
                        <button
                          className={`button button__medium ${(!entrance || errorEntrance) && 'button_disabled'}`}
                          onClick={handleAddPay}
                          disabled={!entrance || errorEntrance}
                        >
                          Внести оплату
                        </button>
                      </div>
                      <div className={styles.buttonGroup}>
                        {/* Доработать кнопку!!! */}
                        <button
                          className={`button button__medium ${(!remainingPayment) && 'button_disabled'}`}
                          onClick={handleAddRemainingPay}
                          disabled={!remainingPayment}
                        >
                          Внести {remainingPayment} руб.
                        </button>
                      </div>
                    </div>
                  </CollapsedContainer>

                  <CollapsedContainer label={'Управление заказом'}
                    showContent={showControl} setShowContent={setShowControl}
                  >
                    {/* управление статусами заказа */}
                    <div className={styles.downloadContainer}>
                      <div className={styles.buttonGroup}>
                        <button
                          className={`button button__medium ${!buttonRepeatEnabled && 'button_disabled'}`}
                          disabled={!buttonRepeatEnabled}
                          onClick={handleRepeatOrder}
                        >
                          Повторить заказ
                        </button>
                        <button
                          className={`button button__medium button__red ${!buttonCancelEnabled && 'button__red_disabled'}`}
                          onClick={handleCancelOrder}
                          disabled={!buttonCancelEnabled}
                        >
                          Отменить заказ
                        </button>
                      </div>

                      {/* этот блок для супера и менеджера */}
                      <div className={styles.buttonGroup}>
                        <button
                          className={`button button__medium ${!buttonAwaitReceiptEnabled && 'button_disabled'}`}
                          onClick={handleAwaitReceipt}
                          disabled={!buttonAwaitReceiptEnabled}
                        >
                          Ожидает получения
                        </button>
                        <button
                          className={`button button__medium ${!buttonReceivedEnabled && 'button_disabled'}`}
                          onClick={handleReceived}
                          disabled={!buttonReceivedEnabled}
                        >
                          Получен
                        </button>
                      </div>

                    </div>
                  </CollapsedContainer>
                </section>
              </> : null
            }
          </>
        }
      </div>
    </main>
  );
};

export default Order;
